import type { ClaimOutcome } from './claimsData'
import { ClaimTimelineStep } from './ClaimTimelineStep'
import type { TimelineStep } from './timelineSteps'

/** One unbroken run of steps — each says for itself who is holding the claim. */
export function ClaimTimeline({ steps, outcome }: { steps: TimelineStep[]; outcome?: ClaimOutcome }) {
  return (
    <div>
      {steps.map((step, index) => (
        <ClaimTimelineStep key={step.key} step={step} outcome={outcome} isLast={index === steps.length - 1} />
      ))}
    </div>
  )
}
